import { styled } from '@mui/material';
import { GridCompact12 } from 'components/shared/Grid/Grid.components';

export const FormWrapper = styled(GridCompact12)({
  height: 'calc(100% - 98px)',
  overflowY: 'auto'
});
